export default {
    bind: function (el, binding) {
        (el as HTMLInputElement).indeterminate = binding.value;
    },
};
